import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";

export const ConfirmAssignRoleDialog = ({
  isOpen,
  onClose,
  onConfirm,
  usersWithExistingRoles,
  targetRoleName,
}) => {
  if (!usersWithExistingRoles || usersWithExistingRoles.length === 0) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "32px 48px 0" }} className="white-to-dark">
        Confirm Role Assignment
      </DialogTitle>
      <DialogContent sx={{ padding: "16px 48px 24px" }}>
        <SoftTypography variant="body2" component="p" gutterBottom>
          The following selected user(s) already have roles assigned. Assigning the role
          <SoftTypography component="span" fontWeight="bold">
            {" "}
            &quot;{targetRoleName}&quot;{" "}
          </SoftTypography>
          will overwrite their current role.
        </SoftTypography>
        <SoftBox component="ul" sx={{ pl: 2, mb: 2 }}>
          {usersWithExistingRoles.map((user, index) => (
            <li key={index}>
              <SoftTypography variant="body2" component="span" fontWeight="bold">
                {user.name}:
              </SoftTypography>
              <SoftTypography variant="body2" component="span">
                {" "}
                Currently has role &quot;{user.currentRoleName}&quot;
              </SoftTypography>
            </li>
          ))}
        </SoftBox>
        <SoftTypography variant="body2" component="p">
          Are you sure you want to proceed?
        </SoftTypography>
      </DialogContent>
      <DialogActions sx={{ padding: "0 48px 32px" }}>
        <SoftButton variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </SoftButton>
        <SoftButton variant="gradient" color="info" onClick={onConfirm}>
          Confirm Assignment
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

ConfirmAssignRoleDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  usersWithExistingRoles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      currentRoleName: PropTypes.string,
    })
  ).isRequired,
  targetRoleName: PropTypes.string,
};
